module.exports = __webpack_public_path__ + "img/Lime-24-Blog-Banner10.ccd4bec7.jpg";